import React from "react";
import { Swiper } from "components/swiper";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow-in-white.svg";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow-in-white.svg";
import { useGlobalContext } from "context/global";

const CollectionSlider = ({ children, amount, className = "" }) => {
	const { isCollection } = useGlobalContext();

	const settings = {
		slidesPerView: amount?.desktop,
		preventClicks: true,
		preventClicksPropagation: true,
		noSwiping: true,
		freeMode: true,
		spaceBetween: isCollection ? 16 : 30,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		slidesPerGroup: 2,
		breakpoints: isCollection ? 
			{
				992: {
					slidesPerView: amount?.desktop ?? 4,
				},
				768: {
					simulateTouch: true,
					slidesPerView: amount?.tablet ?? 3,
					slidesPerGroup: 1,
				},
				320: {
					simulateTouch: true,
					slidesPerView: amount?.mobile ?? 1,
					slidesPerGroup: 1,
				},
			} : 
			{
				1200: {
					slidesPerView: amount?.desktop ?? 4,
				},
				1024: {
					slidesPerView: amount?.tablet ?? 3,
				},
				768: {
					simulateTouch: true,
					slidesPerView: amount?.mobile ?? 2,
					slidesPerGroup: 1,
				},
				320: {
					simulateTouch: true,
					slidesPerView: amount?.mobile ?? 1,
					slidesPerGroup: 1,
				}
			},
		navigation: {
			enabled: true,
			nextEl: ".right-arrow-cs",
			prevEl: ".left-arrow-cs",
		},
		pagination: {
			clickable: true,
		},
		a11y: true,
	};
	return (
		<Swiper {...settings} showLoader className={className} >
			{children}
			<button className="left-arrow-cs" aria-label="Swipe left">
				<LeftArrow role="presentation" aria-hidden="true" />
			</button>
			<button className="right-arrow-cs" aria-label="Swipe right">
				<RightArrow role="presentation" aria-hidden="true" />
			</button>
		</Swiper>
	);
};

export default CollectionSlider;
